import { render, staticRenderFns } from "./farmAdmin.vue?vue&type=template&id=126eea34&scoped=true&"
import script from "./farmAdmin.vue?vue&type=script&lang=js&"
export * from "./farmAdmin.vue?vue&type=script&lang=js&"
import style0 from "./farmAdmin.vue?vue&type=style&index=0&id=126eea34&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126eea34",
  null
  
)

export default component.exports